import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function GamingLicenseTuvalu() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.gaming-license-tuvalu.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/gaming-license–tuvalu"
            />

            <IntroSection
                title={tp('intro.title')}
                description={tp('intro.description')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/Tuvalu Gaming License 3.jpg')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <h1 className='page-title'>{tp('servicesHeading')}</h1>
                    <p className='page-paragraph'>{tp('servicesIntro')}</p>

                    <WhySection title={tp('step1.title')} subtitle={tp('step1.subtitle')} blocks={[{ items: obj('step1.items') }]} />
                    <WhySection title={tp('step2.title')} subtitle={tp('step2.subtitle')} blocks={[{ items: obj('step2.items') }]} />
                    <WhySection title={tp('step3.title')} subtitle={tp('step3.subtitle')} blocks={[{ items: obj('step3.items') }]} />
                    <WhySection title={tp('step4.title')} subtitle={tp('step4.subtitle')} blocks={[{ items: obj('step4.items') }]} />
                    <WhySection title={tp('step5.title')} subtitle={tp('step5.subtitle')} blocks={[{ items: obj('step5.items') }]} />

                    <InfoBlocks
                        blocks={[{
                            title: tp('approach.title'),
                            subtitle: tp('approach.subtitle'),
                            items: obj('approach.items'),
                        }]}
                    />

                    <InfoBlocks
                        blocks={[{
                            title: tp('types.title'),
                            items: obj('types.items'),
                        }]}
                    />

                    <DetailsSection
                        title={tp('who.title')}
                        items={obj('who.items')}
                        end={tp('who.end')}
                    />

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
